<template>
  <div v-if="isTranslationsInitDone">
    <router-view v-if="isTesterPage" class="content-container" />
    <div v-else class="vue-content">
      <top-notification
        v-if="notificationActive"
        :notification-data="notificationData"
        @closeNotification="closeNotification"
      />
      <mega-menu
        v-if="isMobile || (isSiteLoadDone && !site.isMenuHorizontalStyle)"
        :is-mega-menu-open="isMenuOpen"
        @closeMegaMenu="closeMegaMenu"
      />
      <header-component
        :is-showing-not-found-page="isShowingNotFoundPage"
        :is-mega-menu-open="isMenuOpen"
        @toggleMegaMenu="toggleMegaMenu"
        @closeMegaMenu="closeMegaMenu"
      />
      <transition name="fade">
        <not-found v-if="isShowingNotFoundPage" class="content-container" />
        <div v-else-if="!isShowingNotFoundPage && showSlotContent" class="content-container">
          <slot />
        </div>
        <router-view v-else :key="$route.path" class="content-container" />
      </transition>
      <footer-component />
      <cookie-consent v-if="isCookieConsentNeeded" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import VueNoty from 'vuejs-noty'
Vue.use(VueNoty)

export default {
  name: 'App',
  components: {
    'cookie-consent': () => import(/* webpackChunkName: "cookieConsent" */ './components/cookieConsent/cookieConsent.vue'),
    'top-notification': () => import(/* webpackChunkName: "topNotification" */ './components/topNotification/topNotification.vue'),
    'footer-component': () => import(/* webpackChunkName: "footerComponent" */ './components/footer-component/footer-component.vue'),
    'header-component': () => import(/* webpackChunkName: "headerComponent" */ './components/header-component/header-component.vue'),
    'mega-menu': () => import(/* webpackChunkName: "MegaMenu" */ './components/MegaMenu/MegaMenu.vue'),
    'not-found': () => import(/* webpackChunkName: "NotFound" */ './pages/NotFound/NotFound.vue'),
  },
  data() {
    return {
      /**
       * tesztelő oldalon vagyunk-e, ha igen nem kell semmi más
       */
      isTesterPage: window.isTesterPage,
      /**
       * kell-e a cookie consentet megjeleníteni?
       */
      isCookieConsentNeeded: window.isCookieConsentNeeded,
      /**
       * TODO: Dummy szövegek, ezeket majd backendről kapjuk
       */
      notificationData: {
        mainTitle: 'Gratulálunk!',
        description: 'Sok pontod van, ideje beváltani!',
        linkTitle: 'Kattints ide!',
        notificationType: 'coupon',
        linkPath: '#',
      },
      /**
       * jelenleg mutatjuk-e a notification componentet
       */
      notificationActive: false,
      /**
       * nyitva van-e a megamenü?
       */
      isMenuOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      isTranslationsInitDone: 'Site/getIsTranslationsInitDone',
      site: 'Site/getSite',
      isSiteLoadDone: 'Site/isSiteLoadDone',
    }),
    /**
     * mobil nézet-e
     *
     * @return {boolean}
     */
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md'
    },
    /**
     * nem vue page contentet mutatjuk-e
     */
    showSlotContent() {
      return this.$route.name === null
    },
    /**
     * épp a 404 oldal látszik-e
     *
     * @return {default.computed.showNotFoundPage}
     */
    isShowingNotFoundPage() {
      return this.getIsShowingNotFoundPage()
    },
  },
  created() {
    this.$root.$on('showNotFoundPage', this.showNotFound)
    this.$root.$on('hideNotFoundPage', this.hideNotFound)
    // feliratkozás az értesítésekre
    this.$root.$on('notificationPush', this.notificationPush)
  },
  destroyed() {
    this.$root.$off('showNotFoundPage', this.showNotFound)
    this.$root.$off('hideNotFoundPage', this.hideNotFound)
    this.$root.$off('notificationPush', this.notificationPush)
  },
  methods: {
    /**
     * megamenü nyitása, scroll tiltása
     */
    openMegaMenu() {
      this.isMenuOpen = true
      window.disableScroll()
    },
    /**
     * megamenü bezására, scroll engedélyezése
     */
    closeMegaMenu() {
      this.isMenuOpen = false
      window.enableScroll()
    },
    /**
     * megamenü kinyitás/bezárás
     */
    toggleMegaMenu() {
      if (this.isMenuOpen) {
        this.closeMegaMenu()
      } else {
        this.openMegaMenu()
      }
    },
    /**
     * 404 oldal mutatása
     */
    showNotFound() {
      this.setShowNotFoundPage(true)
    },
    /**
     * 404 oldal elrejtése
     */
    hideNotFound() {
      this.setShowNotFoundPage(false)
    },
    /**
     * A header feletti notification sávot 'zárja be'
     */
    closeNotification() {
      // TODO: noty bezárása
    },
    /**
     * Notification megjelenítése
     *
     * @param text
     * @param type
     * @param duration
     */
    notificationPush(text, type, duration = 5000) {
      switch (type) {
        case 'success':
          this.$noty.success(text, { layout: 'bottomCenter', timeout: duration })
          break
        case 'warning':
          this.$noty.warning(text, { layout: 'bottomCenter', timeout: duration })
          break
        case 'error':
          this.$noty.error(text, { layout: 'bottomCenter', timeout: duration })
          break
        default:
          console.error('Nincs ilyen notification: ' + type)
      }
    },
  },
}
</script>

<style lang="scss" src="./App.scss" />
